// Types
import { ErrorNames } from './ErrorNames';
/**
 * @description Returns an instance of error with the name set to FetchError
 *
 * @return { Error } error with name set to FetchError
 */
export var getFetchError = function () {
    var error = new Error();
    error.name = ErrorNames.FETCH;
    return error;
};
//# sourceMappingURL=getFetchError.js.map